import { useEffect, useMemo, useState } from 'react';
import './tag.scss';
import { useSPosStore } from '../../stores/use-spos-store';
import { Vector3 } from 'three';
import emitter, { EVENT_CLICK_TAG } from '../../utils/mitt';
import LazyImage from '../lazy-image/lazy-image';
import { useGlobalStore } from '../../stores/use-global-store';
import clsx from 'clsx';
export default function Tag({ name, posId }: { name: string; posId: string }) {
  const { screenPos } = useSPosStore();
  const [offset, setOffset] = useState(new Vector3());
  const [imagePos, setImagePos] = useState([0, 0]);

  const { camState } = useGlobalStore();
  const shouldHide = useMemo(() => {
    return camState !== 0;
  }, [camState]);

  useEffect(() => {
    let id = 0;
    let lastTime = new Date().getTime() * 0.001;
    let frame = 0;
    let frameNum = 54;
    const anim = () => {
      id = requestAnimationFrame(anim);
      const current = new Date().getTime() * 0.001;
      if (current - lastTime > 1 / 18) {
        lastTime = current;
        frame %= frameNum;
        const c = frame % 14;
        const r = Math.floor(frame / 14);
        frame = (frame + 1) % frameNum;
        setImagePos([c, r]);
      }
    };
    anim();
    return () => {
      cancelAnimationFrame(id);
    };
  }, []);
  useEffect(() => {
    let id = 0;
    const anim = () => {
      id = requestAnimationFrame(anim);
      const spos = screenPos[posId];
      if (spos) {
        setOffset(
          new Vector3(
            Math.max(0, ((spos.x + 1) * window.innerWidth) / 2),
            (-(spos.y - 1) * window.innerHeight) / 2,
            0
          )
        );
      }
    };
    anim();
    return () => {
      cancelAnimationFrame(id);
    };
  }, [posId, screenPos]);

  const chars = useMemo(() => {
    return name.split('');
  }, [name]);

  const toState = () => {
    const index = parseInt(posId.split('-')[1]);
    emitter.emit(EVENT_CLICK_TAG, index);
  };
  return (
    <div
      className={clsx(
        'tag_wrapper',
        'absolute left-0 top-0 cursor-pointer',
        shouldHide && 'pointer-events-none'
      )}
      style={{
        transform: `translate3d(${offset.x}px, ${offset.y}px, 0)`,
      }}
      onClick={toState}
    >
      <div className="fit_parent">
        <LazyImage
          className="w-[1400%] h-[400%] absolute left-0 top-0"
          style={{
            transform: `translate3d(-${(imagePos[0] / 14) * 100}%, -${(imagePos[1] / 4) * 100}%, 0)`,
          }}
          src={process.env.PUBLIC_URL + '/images/tag.png'}
          width={1120}
          height={792}
          fit="cover"
          alt="tag"
        ></LazyImage>
      </div>
      <div className="fit_parent  flex flex-col justify-center gap-[0] items-center mt-[-10%]">
        {chars.map((c, i) => (
          <p
            key={c + i}
            className="tag_text glow_text text-white leading-[1.05]"
          >
            {c}
          </p>
        ))}
      </div>
    </div>
  );
}
